import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ChartData, ChartDataWithId, ChartMetadataExtended } from '../models/charts';
import { QueryRecord, ChartMetadata } from '../../../API';

@Injectable({
  providedIn: 'root',
})
export class ChartDataService {
  private saveChartLoading = false;

  private activeChartData = new BehaviorSubject<ChartData>({ data: [], type: '{}' });
  chartData$ = this.activeChartData.asObservable();

  public selectedChartsForDashboard = new BehaviorSubject<ChartMetadataExtended[]>([]);
  dashboardCharts$ = this.selectedChartsForDashboard.asObservable();

  public allChartsResultData = new BehaviorSubject<ChartDataWithId>({});
  dashboardChartData$ = this.allChartsResultData.asObservable();

  private queryRecordSignal = signal<QueryRecord | null>(null);
  private chartMetadataSignal = signal<ChartMetadata | null>(null);
  private isViewModeSignal = signal<boolean>(false);

  setData(newData: any[]) {
    this.activeChartData.next({
      ...this.activeChartData.value,
      data: newData,
    });
  }

  setType(newType: string) {
    this.activeChartData.next({
      ...this.activeChartData.value,
      type: newType,
    });
  }

  setChartData(value: any) {
    this.activeChartData.next(value);
  }

  get isSaveChartLoading(): boolean {
    return this.saveChartLoading;
  }

  set isSaveChartLoading(loading: boolean) {
    this.saveChartLoading = loading;
  }

  get queryRecord(): QueryRecord | null {
    return this.queryRecordSignal();
  }

  set queryRecord(value: QueryRecord | null) {
    this.queryRecordSignal.set(value);
  }

  get chartMetadata(): ChartMetadata | null {
    return this.chartMetadataSignal();
  }

  set chartMetadata(value: ChartMetadata | null) {
    this.chartMetadataSignal.set(value);
  }

  set isViewMode(value: boolean) {
    this.isViewModeSignal.set(value);
  }

  get isViewMode() {
    return this.isViewModeSignal();
  }
}
